import { useState } from 'react';
import { COURSE, WEEKS, WEEK_TITLES, isLesson, type ProgressView } from '@gc/shared';
import { LessonCard } from '../components/LessonCard.js';

export interface PlanProps {
  progress: ProgressView;
  busy: boolean;
  onToggle: (day: number, done: boolean) => void;
  onTool: (kind: string, id: string) => void;
}

/** Весь курс по неделям: видно, что уже пройдено и что ждёт дальше. */
export function Plan({ progress, busy, onToggle, onTool }: PlanProps): JSX.Element {
  const [week, setWeek] = useState(
    COURSE.days.find((d) => d.day === progress.currentDay)?.week ?? 1,
  );
  const [open, setOpen] = useState<number | null>(progress.currentDay);
  const done = new Set(progress.done);

  return (
    <div className="screen">
      <div className="chips sticky">
        {WEEKS.map((w) => (
          <button
            key={w}
            type="button"
            className="chip"
            aria-pressed={w === week}
            onClick={() => setWeek(w)}
          >
            {w === 5 ? 'Финал' : `Неделя ${w}`}
          </button>
        ))}
      </div>

      <h2 className="week-title">{WEEK_TITLES[week]}</h2>

      <ul className="daylist">
        {COURSE.days
          .filter((d) => d.week === week)
          .map((d) => {
            if (!isLesson(d)) {
              return (
                <li key={d.day} className="rest">
                  <span className="daynum dim">{d.day}</span>
                  <div>
                    <b>{d.title}</b>
                    <p>{d.text}</p>
                  </div>
                </li>
              );
            }
            const isOpen = open === d.day;
            return (
              <li key={d.day} className={done.has(d.day) ? 'is-done' : ''}>
                <button
                  type="button"
                  className="daybtn"
                  onClick={() => setOpen(isOpen ? null : d.day)}
                >
                  <span className="daynum">{d.day}</span>
                  <span className="daytitle">{d.title}</span>
                  <span className="mark">{done.has(d.day) ? '✅' : isOpen ? '▾' : '▸'}</span>
                </button>
                {isOpen && (
                  <LessonCard
                    day={d}
                    done={done.has(d.day)}
                    busy={busy}
                    onToggle={onToggle}
                    onTool={onTool}
                  />
                )}
              </li>
            );
          })}
      </ul>
    </div>
  );
}
